import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const NONE = 'none';

export const useEmailDesignOptions = () => {
  const [designs, setDesigns] = useState([]);
  useEffect(() => {
    axios.get(`${API}/email-designs/options`)
      .then((res) => setDesigns(res.data.designs || []))
      .catch(() => setDesigns([]));
  }, []);
  return designs;
};

export const EmailDesignSelect = ({ value, onChange, designs, testId = 'email-design-select', disabled, showHint = true }) => {
  const selected = designs.find((d) => d.id === value);
  return (
    <div className="space-y-1">
      <Select value={value || NONE} onValueChange={(v) => onChange(v === NONE ? null : v)} disabled={disabled}>
        <SelectTrigger data-testid={testId}><SelectValue placeholder="No design" /></SelectTrigger>
        <SelectContent>
          <SelectItem value={NONE} data-testid={`${testId}-none`}>No design (sent as plain email)</SelectItem>
          {designs.map((d) => (
            <SelectItem key={d.id} value={d.id} disabled={!d.has_email_content} data-testid={`${testId}-option-${d.id}`}>
              {d.name}{!d.has_email_content ? ' (needs an Email Content block)' : ''}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {value && !selected && (
        <p className="text-xs text-amber-600" data-testid={`${testId}-missing`}>The assigned design was deleted. This email is sent as plain email.</p>
      )}
      {selected && !selected.has_email_content && (
        <p className="text-xs text-amber-600" data-testid={`${testId}-warning`}>This design has no Email Content block, so it will not be used.</p>
      )}
      {showHint && designs.some((d) => !d.has_email_content) && (
        <p className="text-xs text-muted-foreground">Designs without an Email Content block can't be picked.</p>
      )}
    </div>
  );
};
